import { Card, Divider, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { UserFeedbackTab } from "src/constants";
import { useUserFeedbackSettings } from "../hooks";
import { UserFeedbackGivenList } from "./UserFeedbackGivenList";
import { UserFeedbackReceivedList } from "./UserFeedbackReceivedList";

interface Props {
  userId: string;
}

const UserFeedbackTabs = (props: Props) => {
  const { settings, updateSettings } = useUserFeedbackSettings(props.userId);
  const [currentTab, setCurrentTab] = useState<UserFeedbackTab>(settings.tab);

  function handleChange(_: React.SyntheticEvent, tab: UserFeedbackTab) {
    setCurrentTab(tab);
    updateSettings({
      tab,
    });
  }

  return (
    <Card>
      <Tabs value={currentTab} onChange={handleChange}>
        <Tab label="Received" value={UserFeedbackTab.Received} disableRipple />
        <Tab label="Given" value={UserFeedbackTab.Given} disableRipple />
      </Tabs>

      <Divider />

      {currentTab === UserFeedbackTab.Received && <UserFeedbackReceivedList userId={props.userId} />}
      {currentTab === UserFeedbackTab.Given && <UserFeedbackGivenList userId={props.userId} />}
    </Card>
  );
};

export { UserFeedbackTabs };
